module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/logo-small-fddc43d912655d43378b752a354cb347.png";